// @format

export function initAutosize(): void {
  $('textarea.autosize').each(function() {
    this.style.height = this.scrollHeight + 10 + 'px';
  });
}
